import React from 'react'
import StepsComponent from '../components/steps'
import axios from 'axios'
import _ from 'lodash'
import jsonToFormData from '@ajoelp/json-to-formdata'
import { Component } from 'react'
import { buildPropertyFromDraft } from '../utils/mapping'
import { withRouter } from 'react-router-dom'


class ModifyPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      draft: {
        masterStep: 0,
        subStep: 0
      },
      loading: true,
      hasError: false
    }
  }

  async componentDidMount () {
    // axios.defaults.headers['Authorization'] = `Bearer ${_.get(this.props, 'api_token')}`
    axios.defaults.headers['Content-Type'] = `application/json`
    axios.defaults.headers['Accept'] = `application/json`
    this.setState({
      loading: true
    })
    try {
      const propertyId = this.props.match.params.propertyId || this.props.match.params.draftId
      const { data: { data: _draft } = {} } = await axios.post(`${process.env.REACT_APP_API_URL}/api/propertylisting/getWithAuth/${propertyId}`)
      if (_.size(_draft) > 0) {
        const draft = buildPropertyFromDraft(_draft)
        const stepper = _.split(_.get(_draft, 'last_step'), ' - ')
        if (_.size(stepper) > 0) {
          draft.masterStep = _.toInteger(_.get(stepper, '[0]'))
          draft.subStep = _.toInteger(_.get(stepper, '[1]'))
        }
        this.setState({
          draft: draft ? {
            ...this.state.draft,
            ...draft,
            user_idFk: _draft.user_idFk
          } : this.state.draft,
          loading: false
        })
      } else {
        this.setState({
          ...this.state,
          loading: false
        })
      }
    } catch (e) {
      this.setState({
        hasError: true,
        loading: false
      })
      window.location.href = process.env.REACT_APP_WEBSITE_PATH
      console.error(e)
    }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  async componentDidCatch (error, errorInfo) {
    await axios.post(`${process.env.REACT_APP_API_URL}/api/propertylisting/notify/failed`, jsonToFormData({
      message: `${_.toString(error)} ${errorInfo.componentStack}`
    }), {
      headers: {
        "Content-Type": 'multipart/form-data;'
      }
    })
  }

  render () {
    if (this.state.hasError || this.state.loading) {
      return null
    }
    return <StepsComponent draft={this.state.draft} setProgress={this.props.setProgress} progress={this.props.progress} />
  }
}

export default withRouter(ModifyPage)
